import { GroupEntity } from '@backstage/catalog-model';
import { Progress } from '@backstage/core-components';
import { ScoreBoard } from './ScoreBoard';
import { ScoreBoardType } from './ScoreBoardType';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useGetRenovateScores } from './hooks/useGetRenovateScores';

import { SimpleScore, useTeamList } from '@internal/ui-common';

export const RenovateScoreBoard = () => {
  const { entity: departmentGroup } = useEntity<GroupEntity>();
  const { teams, isLoading } = useTeamList(departmentGroup);

  const { scores } = useGetRenovateScores({ teams: isLoading ? [] : teams });

  if (isLoading || scores === undefined) {
    return <Progress />;
  }

  return (
    <ScoreBoard<SimpleScore> scores={scores} type={ScoreBoardType.RENOVATE} />
  );
};
